import Todo from '../models/Todo';
import {centerAxiosRequest} from "@/utils/axios";
import {localAxiosRequest} from "@/utils/axios";
const VENDOR_BASE_URL = '/vendor';

/**
 * 获取详情页供应商
 */
const getVendor = function (vendorId: string): Promise<Todo[]> {
    return centerAxiosRequest({
        method: 'GET',
        url: `${VENDOR_BASE_URL}/${vendorId}/vendor`,
    });
};

/**
 * 获取已下单图书详情页供应商
 */
const getOrderVendor = function (vendorId: string): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${VENDOR_BASE_URL}/${vendorId}`,
    });
};

export { getVendor, getOrderVendor };
